import { createIcon } from '@chakra-ui/react';

export const Philosophy = createIcon({
  displayName: `Philosophy`,
  viewBox: `0 0 36.938 46.115`,
  path: (
    <g transform="translate(-1134.984 312.111)">
      <path
        d="M1160.011-310.676s-10.987-.974-15.772,3.146-4.032,9.319-3.9,11.575c.2,3.438-2.835,7.077-3.9,8.849s2.835,1.875,2.835,1.875-.035,9.1,1.506,10.707,4.785.354,8.24-.975,8.421-2.639,8.421-2.639"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="3.283"
        y2="8.192"
        transform="translate(1149.834 -275.814)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M1174.325-292.146a2.327,2.327,0,0,1-2.327,2.327,2.327,2.327,0,0,1-2.326-2.327,2.326,2.326,0,0,1,2.326-2.326A2.327,2.327,0,0,1,1174.325-292.146Z"
        transform="translate(-9.857 -4.81)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M1175.141-292.415A1.279,1.279,0,0,0,1175.4-291l.047.047a1.552,1.552,0,0,1,0,2.2,1.552,1.552,0,0,1-2.195,0l-.046-.047a1.293,1.293,0,0,0-1.828.039,1.291,1.291,0,0,0-.359.876v.132a1.551,1.551,0,0,1-1.552,1.552,1.551,1.551,0,0,1-1.551-1.552h0v-.07a1.279,1.279,0,0,0-.838-1.171,1.28,1.28,0,0,0-1.412.256l-.046.047a1.551,1.551,0,0,1-2.195,0,1.552,1.552,0,0,1,0-2.2l.047-.047a1.292,1.292,0,0,0-.039-1.827,1.289,1.289,0,0,0-.877-.36h-.132a1.551,1.551,0,0,1-1.551-1.552,1.551,1.551,0,0,1,1.551-1.551h.07a1.281,1.281,0,0,0,1.172-.837,1.281,1.281,0,0,0-.259-1.412l-.047-.047a1.552,1.552,0,0,1,0-2.2,1.552,1.552,0,0,1,2.2,0l.047.047a1.283,1.283,0,0,0,1.412.256h.062a1.28,1.28,0,0,0,.776-1.172v-.132a1.551,1.551,0,0,1,1.551-1.551,1.551,1.551,0,0,1,1.552,1.551v.07a1.292,1.292,0,0,0,1.311,1.275,1.291,1.291,0,0,0,.877-.36l.047-.047a1.553,1.553,0,0,1,2.195,0,1.552,1.552,0,0,1,0,2.2l-.047.047a1.282,1.282,0,0,0-.259,1.412v.062a1.282,1.282,0,0,0,1.174.775h.132a1.551,1.551,0,0,1,1.552,1.551,1.551,1.551,0,0,1-1.552,1.552h-.07A1.28,1.28,0,0,0,1175.141-292.415Z"
        transform="translate(-7.261 -2.213)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </g>
  ),
});
